import { AppConfiguration } from "config";
import { MetaTags } from "react-meta-tags";
import { Container } from "reactstrap";
import Breadcrumbs from "components/Common/Breadcrumb"
import { bsh_getAdminUserDetails } from "helpers/sf_browser_storage_helper";


const DataScience = () => {
    const token = bsh_getAdminUserDetails()?.token?.split(' ')?.[1];
    const link_to_ds_app = `${AppConfiguration.DS_APP_URL}?auth_token=${token}`;
    return (
        <div className="page-content" id="page-content-wrapper">
            <MetaTags>
                <title>Data Science | {AppConfiguration.WEBSITE}</title>
            </MetaTags>

            <Container fluid style={{ height: '100vh' }}>
                <Breadcrumbs title="" breadcrumbItem="Data Science" />
                <a href={link_to_ds_app} target="_blank" rel="noreferrer" className="text-sfblue fs-13 fw-bold">Open Separately</a>
                <iframe src={link_to_ds_app} width={'100%'} height={'100%'} className="mt-1" />
            </Container>
        </div>
    )
}

export default DataScience;